'use client';

import { FC, useEffect, useState } from 'react';
import { MINUTES_THRESHOLD_FOR_MARKET_STATUS_CHANGE_NOTIFICATIONS } from '@bts-web/core-features/config';
import { SunsetIcon } from './SunsetIcon';
import { SmallMoonIcon } from './SmallMoonIcon';

interface MarketStatusIconProps {
  marketClosedUntil?: Date;
  marketClosingAt?: Date;
  onClick?: () => void;
}

const getMinutesUntil = (date: Date, now: number): number =>
  Math.round((date.getTime() - now) / 60_000);

const MarketStatusIcon: FC<MarketStatusIconProps> = ({
  marketClosedUntil,
  marketClosingAt,
  onClick,
}) => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 60_000);

    return () => clearInterval(id);
  }, []);

  if (marketClosingAt) {
    const minutesUntilClose = getMinutesUntil(marketClosingAt, now);

    if (
      minutesUntilClose > 0 &&
      minutesUntilClose <=
        MINUTES_THRESHOLD_FOR_MARKET_STATUS_CHANGE_NOTIFICATIONS
    ) {
      return <SunsetIcon ariaLabel="market closing soon" onClick={onClick} />;
    }

    return null;
  }

  if (marketClosedUntil) {
    const minutesUntilOpen = getMinutesUntil(marketClosedUntil, now);

    if (
      minutesUntilOpen > 0 &&
      minutesUntilOpen <=
        MINUTES_THRESHOLD_FOR_MARKET_STATUS_CHANGE_NOTIFICATIONS
    ) {
      return (
        <SmallMoonIcon
          colorToken="warning.fill_primary"
          ariaLabel="market opening soon"
          onClick={onClick}
        />
      );
    }

    return (
      <SmallMoonIcon
        colorToken="brand.fill_primary"
        ariaLabel="market closed"
        onClick={onClick}
      />
    );
  }

  return null;
};

export { MarketStatusIcon };
